import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-transfere-transf',
  templateUrl: './transfere-transf.component.html',
  styleUrls: ['./transfere-transf.component.scss']
})
export class TransfereTransfComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
